// @flow
import i18n from 'i18n-js';
import moment from 'moment';
import * as changeStopRequestAction from '../../../actions/changeStopRequests';

export const validate = (values: Object) => {
  const {
    student,
    from_type,
    dates,
    to_gateway,
  } = values;

  const errors = {};

  if (!student) {
    errors.student = i18n.t('labels.requiredField');
  }

  if (!from_type) {
    errors.from_type = i18n.t('labels.requiredField');
  }

  if (!dates) {
    errors.dates = i18n.t('labels.requiredField');
  }

  if (!to_gateway) {
    errors.to_gateway = i18n.t('labels.requiredField');
  }


  return errors;
};

const getDateArray = (startDate: Date, stopDate: Date) => {
  const dateArray = [];
  const currentDate = new Date(startDate);
  const endDate = new Date(stopDate);
  while (currentDate <= endDate) {
    dateArray.push(new Date(currentDate).toISOString().substr(0, 10));
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dateArray;
};

export const onSubmit = (values: Object, dispatch: Function, props: Object) => {
  const { date_range } = values;
  const dateArray = getDateArray(date_range.startDate, date_range.endDate);
  const utcDateArray = [];
  dateArray.forEach(elm => {
    const utcdate = moment(elm).local().format('YYYY-MM-DD').toString();
    utcDateArray.push(utcdate);
  });
  dispatch(changeStopRequestAction.changeStopRequestCreateStarted({
    ...values,
    student: parseInt(values.student.id, 10),
    to_stop: values.to_stop ? parseInt(values.to_stop.id, 10) : undefined,
    date_range: utcDateArray,
    school: props.schoolId,

  }));
};



// WEBPACK FOOTER //
// ./src/scripts/components/CreateChangeStopRequestPopupContent/CreateChangeRequestPopupForm/utils.js